/** Normaliza teléfono a dígitos; asume Colombia (+57) si tiene 10 dígitos. */
export function normalizePhoneDigits(telefono) {
  const digits = String(telefono || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('57') && digits.length >= 12) return digits;
  if (digits.length === 10) return `57${digits}`;
  return digits;
}

export function getEmprendimientoWhatsAppHref(item, message) {
  const digits = normalizePhoneDigits(item?.telefono);
  if (!digits) return '';
  const text = message || `Hola, vi su emprendimiento "${item?.nombre || ''}" en Coonaltragas y me gustaría más información.`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

export function formatEmprendimientoPhone(telefono) {
  const raw = String(telefono || '').trim();
  return raw || '';
}

export function ensureHttpUrl(url) {
  const value = String(url || '').trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
}
